import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'nl',
  months: [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
  weekdaysMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D-M-YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D-M-YYYY',
    'l-Y': 'D-M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd D MMM YYYY HH:mm',
    'llll-Y': 'ddd D MMM HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: '%s jaar geleden', other: '%s jaar geleden' },
    M: { one: '%s maand geleden', other: '%s maanden geleden' },
    w: { one: '%s week geleden', other: '%s weken geleden' },
    d: { one: '%s dag geleden', other: '%s dgn geleden' },
    h: { one: '%s uur geleden', other: '%s uur geleden' },
    m: { one: '%s min. geleden', other: '%s min. geleden' },
    s: { one: '%s sec. geleden', other: '%s sec. geleden' },
  },
  future: {
    y: { one: 'over %s jaar', other: 'over %s jaar' },
    M: { one: 'over %s maand', other: 'over %s maanden' },
    w: { one: 'over %s week', other: 'over %s weken' },
    d: { one: 'over %s dag', other: 'over %s dgn' },
    h: { one: 'over %s uur', other: 'over %s uur' },
    m: { one: 'over %s min.', other: 'over %s min.' },
    s: { one: 'over %s sec.', other: 'over %s sec.' },
  },
  abbr: {
    y: { one: '%s jr', other: '%s jr' },
    M: { one: '%s m', other: '%s m' },
    w: { one: '%s w', other: '%s w' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s u', other: '%s u' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: 'zojuist',
  yesterday: 'Gisteren',
  today: 'Vandaag',
  tomorrow: 'Morgen',
  weekStart: 1,
};
const localeName: LocaleName = 'nl';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
